type PauseFn = () => void;

let activePause: PauseFn | undefined;

export const claimAudioFocus = (pause: PauseFn) => {
	if (activePause && activePause !== pause) {
		activePause();
	}
	activePause = pause;
};

export const releaseAudioFocus = (pause: PauseFn) => {
	if (activePause === pause) {
		activePause = undefined;
	}
};

export const interruptActiveAudio = () => {
	if (activePause) {
		activePause();
		activePause = undefined;
	}
};
